<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true" :text="uploadMsg">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Update Profile</template>
          <b-row v-if="photo" class="py-2 justify-content-md-center">
            <b-col cols="12" class="text-center">
              <img :src="baseURL+'/u/'+photo" width="auto" height="150px" />
            </b-col>
          </b-row>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="8">
              <b-row>
                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('fullname')}">
                    <b-form-group label="Name *">
                      <b-form-input
                        v-model="fullname"
                        type="text"
                        id="fullname"
                        placeholder="Full Name"
                        required
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('fullname')">
                        <span style="color:red;">{{validation.firstError('fullname')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                
                
                <!-- <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('designation')}">
                    <b-form-group label="Designation *">
                      <b-form-input
                        v-model="designation"
                        type="text"
                        id="designation"
                        placeholder="Designation"
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('designation')">
                        <span style="color:red;">{{validation.firstError('designation')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col> -->
                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('phone')}">
                    <b-form-group label="Phone No *">
                      <b-form-input
                        v-model="phone"
                        type="text"
                        id="phone"
                        placeholder="Phone Number"
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('phone')">
                        <span style="color:red;">{{validation.firstError('phone')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="12" md="6">
                  <!-- <div :class="{error: validation.hasError('email')}"> -->
                    <b-form-group label="Email ">
                      <b-form-input v-model="email" type="email" id="email" placeholder="Email"></b-form-input>

                      <!-- <template slot="description" v-if="validation.firstError('email')">
                        <span style="color:red;">{{validation.firstError('email')}}</span>
                      </template> -->
                    </b-form-group>
                  <!-- </div> -->
                </b-col>
                <b-col cols="12" md="6">
                  <div :class="{error: validation.hasError('role')}">
                    <b-form-group label="Role">
                      <b-form-select v-model="role" :disabled="true" :options="userTypes"></b-form-select>
                      <template slot="description" v-if="validation.firstError('role')">
                        <span style="color:red;">{{validation.firstError('role')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              
              </b-row>
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center text-center">
            <b-col cols="12">
              <img v-if="newImage" :src="newImage" width="auto" height="150px" />
            </b-col>
          </b-row>
          <!-- <b-row class="py-2 justify-content-md-center">
            <b-col cols="12" md="6">
              <b-form-group label="Update Profile Picture">
                <b-form-file id="fileInput" :plain="false" v-model="image" @change="showImage"></b-form-file>
              </b-form-group>
            </b-col>
          </b-row> -->
          <b-row class="py-2 justify-content-md-center">
            <span style="color:red">{{msg}}</span>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button variant="outline-primary" size="sm" @click.prevent="inputCheck">Submit</b-button>
            </div>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      msg: null,
      userTypes: [
        "admin",
        "user",
        
      ],
      fullname: null,
      lastname: null,
      username: null,
      phone: null,
      email: null,
      designation: null,
      role: "Researcher",
      division: null,
      range: null,
      divisions: [],
      ranges: [],
      photo: null,
      image: null,
      uploadMsg: "",
      newImage: null,
    };
  },
  beforeMount() {
    this.getData();
   
  },
 
  validators: {
    fullname(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[a-zA-Z ]+$", " Name can only use Letters")
        .minLength(3, "Minimum 3 Characters Needed");
    },
    // username(value) {
    //   return this.Validator.value(value)
    //     .required("Required Field")
    //     .regex(
    //       "^[a-z0-9_.-]*$",
    //       "Usernames can only use lowercase letters, numbers, underscores and periods."
    //     );
    // },
    phone(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^(?=.*[0-9])", "Please Input Valid Number.");
    },
    // email(value) {
    //   return this.Validator.value(value).required("Required Field").email();
    // },
    // designation(value) {
    //   return this.Validator.value(value).required("Required Field");
    // },
    role(value) {
      return this.Validator.value(value).required("Required Field");
    },
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/user/me",
        method: "POST",
        headers: {
          "token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          var user = response.data.data;
          this.fullname = user.name;
         
          
         
          this.phone = user.phone;
          this.email = user.email;
          this.role = user.role;
          this.photo = user.photo;
          if (user.division) this.division = user.division._id;
          if (user.range) this.range = user.range._id;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getDivisions() {
      this.appLoading = true;
      axios({
        url: "/division/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: 0,
          page: 0,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.divisions = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    getRanges(item) {
      this.appLoading = true;
      axios({
        url: "/range/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: 0,
          page: 0,
          division: item,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.ranges = response.data.data;
          if (this.ranges.length < 1) {
            if (
              this.user.role == "Informant" ||
              this.user.role == "Subscriber"
            ) {
              this.msg = "Please Add a range to the selected Division";
            }
          } else this.msg = null;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    inputCheck() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.editUser();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },
    editUser() {
      this.appLoading = true;
      var user = {};
      
      user["name"] = this.fullname;
      
     
      user["phone"] = this.phone;
     
      user["email"] = this.email;
      axios({
        method: "POST",
        url: "/user/profile/edit",
        headers: {
          "token": localStorage.getItem("token"),
        },
        data: user,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (this.image) {
              this.uploadImage();
            } else {
              this.$router.go(-1);
            }
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
        });
    },
    showImage(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.newImage = null;
        return;
      }
      if (files[0].size > 5242880) {
        this.msg = "File size Should be less than 5MB";
        return;
      } else {
        this.msg = null;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        this.newImage = e.target.result;
      };
      reader.readAsDataURL(files[0]);
    },
    uploadImage() {
      var vm = this;
      this.appLoading = true;
      let formData = new FormData();
      formData.append("photo", this.image);
      axios({
        method: "POST",
        url: "/user/photo",
        headers: {
          "Content-Type": "multipart/form-data",
          "x-auth-token": localStorage.getItem("token"),
        },
        data: formData,
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          vm.uploadMsg = "Uploading " + percentCompleted + "%";
          // if (percentCompleted == 100) vm.uploadMsg = "";
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch((err) => {
          this.ServerError = true;
        });
    },
  },
};
</script>
